var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.504,
    height: 22.504,
    viewBox: "0 0 22.504 22.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call-2",
    "data-name": "call",
    transform: "translate(1.875 1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.725,15.312a2.387,2.387,0,0,1-.234,1.022,3.869,3.869,0,0,1-.638.956A4.227,4.227,0,0,1,16.315,18.4a4.709,4.709,0,0,1-1.828.356,7.814,7.814,0,0,1-3.057-.684A16.469,16.469,0,0,1,8.2,16.212a26.958,26.958,0,0,1-3.076-2.625,26.642,26.642,0,0,1-2.616-3.066,16.717,16.717,0,0,1-1.838-3.2A7.9,7.9,0,0,1,0,4.257a4.851,4.851,0,0,1,.338-1.81A4.316,4.316,0,0,1,1.416.881,2.747,2.747,0,0,1,3.366,0a1.762,1.762,0,0,1,.76.169,1.529,1.529,0,0,1,.628.525L6.929,3.76a3.209,3.209,0,0,1,.375.656,1.482,1.482,0,0,1,.131.572,1.273,1.273,0,0,1-.2.666,3.189,3.189,0,0,1-.525.666L6,7.061a.5.5,0,0,0-.15.375.851.851,0,0,0,.028.216c.028.075.056.131.075.188a7.781,7.781,0,0,0,.872,1.2c.422.488.872.985,1.36,1.482.506.5.994.956,1.491,1.378a7.2,7.2,0,0,0,1.21.863c.047.019.1.047.169.075a.647.647,0,0,0,.234.038.516.516,0,0,0,.384-.159l.713-.7a2.877,2.877,0,0,1,.675-.525,1.249,1.249,0,0,1,.666-.2,1.5,1.5,0,0,1,.572.122,3.627,3.627,0,0,1,.656.366l3.1,2.2a1.422,1.422,0,0,1,.516.6A1.924,1.924,0,0,1,18.725,15.312Z",
    fill: "none",
    stroke: "#00afaa",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H22.5V22.5H0Z",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall2);
export default __webpack_public_path__ + "static/media/call2.9d114df6d6cf04e73eb8ee520d5daacd.svg";
export { ForwardRef as ReactComponent };